export default __webpack_public_path__ + "close-watchlist-5921dbbf31dff97b1f8e1a77eaecc3f8.png";